export const types = {
  GET_ASSOCIATES: 'GET_ASSOCIATES',
};